import { t } from "@/i18n-js/instance";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.community";

export const CommunityUsageDetails = () => (
  <UsageDetailsSection title={t(`${localeRoot}.title`)}>
    <UsageMetric
      title={t(`${localeRoot}.spaces.title`)}
      progress={50}
      description={t(`${localeRoot}.spaces.description`)}
    />
    <UsageMetric
      title={t(`${localeRoot}.admins.title`)}
      progress={50}
      description={t(`${localeRoot}.admins.description`)}
    />
    <UsageMetric
      title={t(`${localeRoot}.moderators.title`)}
      progress={50}
      description={t(`${localeRoot}.moderators.description`)}
    />
    <UsageMetric
      title={t(`${localeRoot}.live_stream_hours.title`)}
      progress={50}
      description={t(`${localeRoot}.live_stream_hours.description`)}
    />
  </UsageDetailsSection>
);
